import { createAsyncThunk } from '@reduxjs/toolkit';
import { http } from '../../../helpers/request';

const PRODUCT_TAGS_TTL_MS = 10 * 1000; //10 Seconds
const BASE_URL = '/FavoriteProductTags';

type StateWithFavoriteProductTagReducer = { favoriteProductTagReducer: { byFavoriteProductId: Record<number, { fetchedAt?: number }> } };

export const getFavoriteProductTagsByFavoriteProductIdAction = createAsyncThunk<any, number, { state: StateWithFavoriteProductTagReducer }>(
    'favoriteProductTags/getByFavoriteProduct',
    async (favoriteProductId: number) => {
        const result = await http<any, undefined>({
            path: `${BASE_URL}/favorite-product/${favoriteProductId}`,
            method: 'get',
        });
        const data = result.parsedBody?.data ?? result.parsedBody ?? [];
        return { favoriteProductId, tags: data };
    },
    {
        condition: (favoriteProductId, { getState }) => {
            const entry = getState().favoriteProductTagReducer.byFavoriteProductId[favoriteProductId];
            if (entry?.fetchedAt && Date.now() - entry.fetchedAt < PRODUCT_TAGS_TTL_MS) {
                return false;
            }
            return true;
        },
    },
);

export const getFavoriteProductTagsByFavoriteProductIdsAction = createAsyncThunk<any, number[]>(
    'favoriteProductTags/getByFavoriteProducts',
    async (favoriteProductIds: number[]) => {
        const query = favoriteProductIds.map((id) => `ids=${id}`).join('&');
        const result = await http<any, undefined>({
            path: `${BASE_URL}/favorite-products?${query}`,
            method: 'get',
        });
        return result.parsedBody?.data ?? result.parsedBody ?? [];
    },
);

export const createFavoriteProductTagAction = createAsyncThunk<any, { favoriteProductId: number; tagId: number }>(
    'favoriteProductTags/create',
    async ({ favoriteProductId, tagId }) => {
        const result = await http<any, { favoriteProductId: number; tagId: number }>({
            path: BASE_URL,
            method: 'post',
            body: { favoriteProductId, tagId },
        });
        const created = result.parsedBody?.data ?? result.parsedBody;
        return { favoriteProductId, created };
    },
);

export const deleteFavoriteProductTagAction = createAsyncThunk<any, number>(
    'favoriteProductTags/delete',
    async (id: number) => {
        await http<any, number>({
            path: `${BASE_URL}/${id}`,
            method: 'delete',
        });
        return { id };
    },
);

export const bulkDeleteFavoriteProductTagsAction = createAsyncThunk<void, number[]>(
    'favoriteProductTags/bulkDelete',
    async (ids: number[]) => {
        await Promise.all(
            ids.map((id) =>
                http<any, undefined>({
                    path: `${BASE_URL}/${id}`,
                    method: 'delete',
                }),
            ),
        );
    },
);
